import styled from 'styled-components'

import NumberInput from '../basic-components/NumberInput'
import TextInput from '../basic-components/TextInput'

const Label = styled.label`
  flex: none;
  display: inline-block;
  text-align: right;
  padding: 0.7rem;
`
const RowContainer = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-evenly;
`

export default function ByAddressDialog({streetNumber, streetName, onStreetNumberChange, onStreetNameChange}) {

  const streetNumberChangeHandler = (e) => {
    onStreetNumberChange(e.target.value);
  }

  const streetNameChangeHandler = (e) => {
    onStreetNameChange(e.target.value);
  }

  return (
      <>
        <RowContainer>
          <Label>Street Number:</Label>
          <NumberInput
             value={streetNumber}
             onChange={streetNumberChangeHandler}
             placeholder={""}
             autoFocus={true}

           />
         </RowContainer>
         <RowContainer>
           <Label>Street Name:</Label>
           <TextInput
              value={streetName}
              onChange={streetNameChangeHandler}
              placeholder={""}
            />
          </RowContainer>
      </>
  );
}
